import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { handleImageDialogClose } from '../../../../../common/properties/formFunctions';

const UploadErrorDialog = ({ component, uploadImageError }) => {
  const uploadImageErrorActions = [
    <FlatButton
      label="Halda áfram" labelStyle={{ color: '#222222' }}
      onTouchTap={() => handleImageDialogClose(component)}
    />,
  ];

  return (
    <Dialog
      title="Villa við það að hlaða inn mynd" actions={uploadImageErrorActions}
      modal={false} open={uploadImageError}
      onRequestClose={() => handleImageDialogClose(component)}
    >
      Upphlaðnar myndir mega ekki vera stærri en 2MB!
    </Dialog>
  );
};

UploadErrorDialog.propTypes = {
  component: React.PropTypes.any.isRequired,
  uploadImageError: React.PropTypes.bool.isRequired,
};

export default UploadErrorDialog;



// WEBPACK FOOTER //
// ./src/browser/app/components/Dialogs/UploadErrorDialog/UploadErrorDialog.js